import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import {
  AVERAGE_GAMELIFT_STREAMS_INIT_TIME,
  AVERAGE_UE_INITIALIZATION_TIME,
} from '@core/dashboard/components/DashboardContent/GameCast/GameCastLoader/hooks';
import { getTeleportToHubDelay } from '@core/dashboard/components/DashboardContent/GameCast/GameCastLoader/helper';
import { useMytaverseEvent } from '@core/dashboard/providers';

import { useStyles } from './styles';
import { withTranslation, WithTranslation } from 'react-i18next';

interface ILoaderText extends WithTranslation {
  step: number;
}

const LoaderText = ({ step, t: translate }: ILoaderText) => {
  const classes = useStyles();

  const { currentEvent } = useMytaverseEvent();

  const delay =
    getTeleportToHubDelay(!!currentEvent?.enablePureGamecast) / 1000;

  const [time, setTime] = useState(() => {
    if (step === 1) {
      return (
        AVERAGE_GAMELIFT_STREAMS_INIT_TIME + AVERAGE_UE_INITIALIZATION_TIME
      );
    } else if (step === 2) {
      return AVERAGE_UE_INITIALIZATION_TIME + delay;
    } else {
      return delay;
    }
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    let newTime;
    if (step === 1) {
      newTime =
        AVERAGE_GAMELIFT_STREAMS_INIT_TIME + AVERAGE_UE_INITIALIZATION_TIME;
    } else if (step === 2) {
      newTime = AVERAGE_UE_INITIALIZATION_TIME + delay;
    } else {
      newTime = delay;
    }
    setTime(newTime);
  }, [step, delay]);

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  return (
    <Box sx={classes.progressTextWrap}>
      <Typography sx={classes.progressText}>
        {translate('loading.loadingTime')}
      </Typography>
      <Typography sx={classes.timer}>{formatTime(time)}</Typography>
    </Box>
  );
};

export default withTranslation()(LoaderText);
